
import Error from 'rde-view-common/components/SystemError';

/**
 * エラーレイアウト
 */
export default {
  components: { Error },
  props: {
    error: {
      type: Object,
      default: null
    }
  }
};
